import { ActivityTypeEnum, EventPublishingStateEnum, InterestsEnum, LocationSearchModeEnum } from '../../enums';
import { IsArray, IsOptional } from "class-validator";
import { Transform } from "class-transformer";
import { DateFilter } from "../../interfaces/filters/date.filter";
import { PaginationFilter } from "../../interfaces/filters/pagination.filter";
import { stringToBooleanNullable, arrayOrStringToArray, stringToInt } from '../../types-transformers';

export class UsersToPastEventsFilter implements DateFilter {
	@IsOptional()
	@IsArray()
	public fitnessTypes?: { id: InterestsEnum; masteryLevels?: number[] | null }[];

	public search?: string;

	/**
	 * select entries only from the specified user
	 */
	public userId?: string;

	/**
	 * select entries only for the specified event author
	 */
	public hostId?: string;

	/**
	 * exclude entries from specified users
	 */
	public excludedUsersIds?: string[];

	/**
	 * select entries specified past events
	 */
	public pastEventIds?: string[];

	/**
	 * select entries specified ids
	 */
	public ids?: string[];

	/**
	 * when true, drafts are included to the response
	 */
	public withDrafts?: boolean;

	/**
	 * when true, events with draft users_to_past_events are included to the response
	 */
	public withGroupedDraftUsersToPastEvents?: boolean;

	/**
	 * when true, every response entry include files (3 latest files entries with metadata and timestamps)
	 */
	public includeFiles?: boolean;

	/** default = PastEventsService.MAX_SELECTED_FILES_PER_USER_TO_EVENT */
	public filesLimit?: number;

	/**
	 * When true, shows only SweatPals' events
	 */
	public onlySubscriptions?: boolean;

	/**
	 * When true, shows all entries without privacy filtering (only for Admins)
	 */
	public ignorePrivacyFiltering?: boolean;

	/**
	 * When true, shows only entries with comments
	 *
	 * When false, shows only entries without comments
	 *
	 * When undefined, shows all entries
	 * @type {boolean}
	 */
	public onlyWithComment?: boolean;

	public countryId?: string;
	public stateId?: string;
	public cityId?: string;

	public periodFrom?: Date;
	public periodTo?: Date;
	public limit: number;
	public lastUserToPastEventId?: string;
	public lastGroupedPastEventId?: string;
	public orderBy?: 'startedAt' | 'updatedAt';

	public onlyNotFeedSynced?: boolean;
}

export class JournalsForHostFilter {
	public hostId: string;
	public limit: number;
	public includeFiles?: boolean;
	public onlyWithComment?: boolean;
}

export class PastEventsFilter implements PaginationFilter {
	@Transform(arrayOrStringToArray)
	ids?: string[];

	@Transform(arrayOrStringToArray)
	public attendeesIds?: string[];

	@Transform(arrayOrStringToArray)
	public fitnessTypeIds?: string[];

	@Transform(stringToBooleanNullable)
	public paid?: boolean | null;

	@Transform(stringToBooleanNullable)
	public isDonationBased?: boolean | null;

	@Transform(stringToInt)
	public costGte?: number;

	@Transform(stringToInt)
	public costLte?: number;

	@Transform(arrayOrStringToArray)
	public authorIds?: string[];

	/** @deprecated needs testing */
	@Transform(stringToBooleanNullable)
	public includeAttendees?: boolean;

	@Transform(stringToBooleanNullable)
	public includeParticipants?: boolean;

	@Transform(stringToBooleanNullable)
	public includeEventTicketsCount?: boolean;

	public search?: string;

	public hostId?: string;
	public countryId?: string;
	public stateId?: string;
	public cityId?: string;
	public citySearchMode?: LocationSearchModeEnum;

	public pageSize?: number;
	public page?: number;

	public includeRevenueForHost?: boolean;
	public publishingStates?: EventPublishingStateEnum[];
}

export class FeedActivitiesFilter {
	lastActivityId?: string;
	limit?: number;
	offset?: number;
	feedUserId?: string;
	activityType?: ActivityTypeEnum;
}
